import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
var _excluded = ["action", "onClose"];

var _dec, _class, _class2, _temp;

import React from 'react';
import { func, shape, string } from 'prop-types';
import { locale } from "../../../lib/locale/decorators";
import { CrossIcon } from "../../../internal/icons/CrossIcon";
import { ZIndex } from "../../../internal/ZIndex";
import { ThemeContext } from "../../../lib/theming/ThemeContext";
import { CommonWrapper } from "../../../internal/CommonWrapper";
import { rootNode } from "../../../lib/rootNode";
import { isTheme2022 } from "../../../lib/theming/ThemeHelpers";
import { CloseButtonIcon } from "../../../internal/CloseButtonIcon/CloseButtonIcon";
import { styles } from "../ToastView.styles";
import { ToastDataTids } from "../Toast";
import { ToastLocaleHelper } from "../locale";
export var ToastView = (_dec = locale('Toast', ToastLocaleHelper), rootNode(_class = _dec(_class = (_temp = _class2 = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(ToastView, _React$Component);

  function ToastView() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _this.renderMain = function (props) {
      var action = props.action,
          onClose = props.onClose,
          rest = _objectWithoutPropertiesLoose(props, _excluded);

      var link = action ? /*#__PURE__*/React.createElement("button", {
        "aria-label": action['aria-label'],
        "data-tid": ToastDataTids.action,
        className: styles.link(_this.theme),
        onClick: action.handler
      }, action.label) : null;
      var close = action ? /*#__PURE__*/React.createElement("span", {
        className: styles.closeWrapper(_this.theme)
      }, /*#__PURE__*/React.createElement("span", {
        "aria-label": _this.locale.closeButtonAriaLabel,
        "data-tid": ToastDataTids.close,
        className: styles.close(_this.theme),
        onClick: onClose
      }, /*#__PURE__*/React.createElement(CrossIcon, null))) : null;

      if (isTheme2022(_this.theme) && close) {
        close = /*#__PURE__*/React.createElement("span", {
          className: styles.closeWrapper(_this.theme)
        }, /*#__PURE__*/React.createElement(CloseButtonIcon, {
          "aria-label": _this.locale.closeButtonAriaLabel,
          "data-tid": ToastDataTids.close,
          onClick: onClose,
          size: parseInt(_this.theme.toastCloseSize),
          side: 40,
          color: _this.theme.toastCloseColor,
          colorHover: _this.theme.toastCloseHoverColor,
          tabbable: false
        }));
      }

      return /*#__PURE__*/React.createElement(ZIndex, {
        priority: "Toast",
        className: styles.wrapper(_this.theme)
      }, /*#__PURE__*/React.createElement("div", _extends({
        "data-tid": ToastDataTids.toastView
      }, rest, {
        className: styles.root(_this.theme),
        ref: _this.setRootNode
      }), /*#__PURE__*/React.createElement("span", null, _this.props.children), link, close));
    };

    return _this;
  }

  var _proto = ToastView.prototype;

  _proto.render = function render() {
    var _this2 = this;

    return /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, function (theme) {
      _this2.theme = theme;
      return /*#__PURE__*/React.createElement(CommonWrapper, _this2.props, _this2.renderMain);
    });
  };

  return ToastView;
}(React.Component), _class2.propTypes = {
  /**
  * Adds action handling and close icon for toast
  */
  action: shape({
    label: string.isRequired,
    handler: func.isRequired
  }),

  /**
  * Toast content
  */
  children: string.isRequired,
  onClose: func
}, _temp)) || _class) || _class);